module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-christmas-right-711e3401e28f256dce5ef4ce4ae27f0e.svg";